import {
  AfterViewChecked,
  Component,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UserLicense } from 'src/app/models/user-graph.model';
import { ToolBoxService } from 'src/app/services/toolbox/toolbox.service';

@Component({
  selector: 'app-licenses-table',
  templateUrl: './licenses-table.component.html',
  styleUrl: './licenses-table.component.scss',
  standalone: false,
})
export class LicensesTableComponent
  implements AfterViewChecked, OnChanges, OnInit
{
  dataSourceLicenses = new MatTableDataSource<UserLicense>([]);
  licensesNameFilter: FormControl = new FormControl('');
  licensesHasConflictFilter: FormControl = new FormControl('');
  defaultColumns: string[] = ['photo', 'displayName'];
  displayedColumnsLicenses: string[] = [...this.defaultColumns];

  isBusy: boolean;
  filterValuesLicenses = {
    displayName: '',
    status: '',
  };

  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };

  @Input() userLicenses: UserLicense[];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private _toolboxService: ToolBoxService) {}

  ngAfterViewChecked() {
    if (!this.dataSourceLicenses.sort || !this.dataSourceLicenses.paginator) {
      this.dataSourceLicenses.sort = this.sort;
      this.dataSourceLicenses.paginator = this.paginator;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userLicenses'] && changes['userLicenses'].currentValue) {
      this.initLicensesFilter();
      this.initializeDataSource();
    }
  }

  ngOnInit() {
    this.setVisibleColumns();
    this.initLicensesFilter();
    this.initializeDataSource();
  }

  async initializeDataSource() {
    this.dataSourceLicenses = new MatTableDataSource(this.userLicenses);
    this.dataSourceLicenses.filterPredicate = this.createLicensesFilter();
  }

  createLicensesFilter(): (data: UserLicense, filter: string) => boolean {
    const filterFunction = (data, filter): boolean => {
      const searchTerms = JSON.parse(filter);
      return (
        data.displayName.toLowerCase().indexOf(searchTerms.displayName) !== -1
      );
    };
    return filterFunction;
  }

  initLicensesFilter() {
    this.licensesNameFilter.valueChanges.subscribe(name => {
      this.filterValuesLicenses.displayName = name.toLowerCase();
      this.dataSourceLicenses.filter = JSON.stringify(
        this.filterValuesLicenses
      );
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.setVisibleColumns();
  }

  setVisibleColumns() {
    this.displayedColumnsLicenses = [...this.defaultColumns];

    if (window.innerWidth < 420) {
      this._toolboxService.hideTableColumnWithoutExpand(
        'photo',
        this.displayedColumnsLicenses
      );
    }
  }
}
